import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var align_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M13 5.5H4V4h9v1.5Zm7 7H4V11h16v1.5Zm-7 7H4V18h9v1.5Z" }) });
export {
  align_left_default as default
};
//# sourceMappingURL=align-left.js.map
